<template>
  <div id="app">

    <div class="controls">
      <div class="control-date">
        <h1>{{getMonthName()}}</h1>
        <input type="range" min="1" max="12" v-model="month">
      </div>

      <div class="control-date">
        <h1>{{day}}<sup>{{getDateSuffix()}}</sup></h1>
        <input type="range" min="1" max="31" v-model="day">
      </div>
    </div>


    <div class="wrapper" v-if="solution !== undefined">
      <div class="row" v-for="(row, r) in solution" :key="r">
        <CalendarCell v-for="(x, c) in row"
                      :key="c"
                      :row="r"
                      :col="c"
                      :has-block="x.match(/1-8/)"
                      :is-grid="x !== '@' || isBlankCell(r, c)"
                      :has-top-edge="r === 0 || solution[r - 1][c] !== x"
                      :has-bottom-edge="r === NUM_ROWS - 1 || solution[r + 1][c] !== x"
                      :has-left-edge="c === 0 || solution[r][c - 1] !== x"
                      :has-right-edge="c === NUM_COLS - 1 || solution[r][c + 1] !== x"
                      :content="getContent(r, c)"
                      :color="colorPalette(x)"
                      :hover="isBlockHover(x)"
                      @mouseenter="updateHover(x, true)"
                      @mouseleave="updateHover(x, false)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CalendarCell from './components/CalendarCell.vue'
import {loadSolution, NUM_ROWS, NUM_COLS} from './puzzle'

function defaultSolution() {
  return loadSolution(1, 1)
}

export default {
  name: 'App',
  components: {
    CalendarCell
  },
  setup() {
    return {
      NUM_ROWS: NUM_ROWS,
      NUM_COLS: NUM_COLS
    }
  },
  props: {},
  data() {
    return {
      month: new Date().getMonth() + 1,
      day: new Date().getDate(),
      hovers: [0, 0, 0, 0, 0, 0, 0, 0, 0]
      // solution: defaultSolution()
    }
  },
  created() {
    defaultSolution()
    console.log(this.solution)
  },
  computed: {
    solution() {
      return loadSolution(this.month, this.day)
    }
  },
  methods: {
    isBlankCell(r, c) {
      return this.solution[r][c] === '0'
    },
    colorPalette(index) {
      const pallete = {
        0: "#830a0a",
        1: "#3e4f93",
        2: "#edeee7",
        3: "#a1382a",
        4: "#e4cd2b",
        5: "#1b4181",
        6: "#d5dade",
        7: "#b22121",
        8: "#deb509",
        '@': "#5f0909",
      }
      if (pallete[index] !== undefined) {
        return pallete[index]
      }
      return "#222"
    },
    isBlockHover(x) {
      if (x < 1 || x > 8)
        return false
      return !!this.hovers[x]
    },
    updateHover(x, status) {
      x = parseInt(x)
      if (x < 1 || x > 8)
        return
      this.hovers[x] = !!status
    },
    getDateSuffix() {
      const date = this.day
      if (date % 10 === 1 && date !== 11)
        return 'st'
      if (date % 10 === 2 && date !== 12)
        return 'nd'
      return 'th'
    },
    getMonthName() {
      const monthNames = "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sept,Oct,Nov,Dec".split(',')
      return monthNames[this.month - 1]
    },
    getContent(r, c) {
      if (this.solution[r][c] === '@')
        return ' '
      if (!this.isBlankCell(r, c))
        return this.solution[r][c]
      return r < 2 ? this.getMonthName() : `${this.day}${this.getDateSuffix()}`;
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.wrapper {
  /*background-color: #830a0a;*/
  background-color: #5f0909;
  padding: 2rem;
  margin-left: auto;
  border-radius: 1rem;
  transform: perspective(800px)
    rotateX(50deg);
  transform-style: preserve-3d;
  -webkit-transform: perspective(800px)
    rotateX(50deg);
  -webkit-transform-style: preserve-3d;
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.wrapper > :nth-child(2) {
  /*border: 1px solid red;*/
  /*margin-bottom: 3rem;*/
}

.controls {
  /*position: absolute;*/
  left: 20px;
  top: 20px;
  width: 300px;
  height: 30px;
  display: flex;
}

h1 {
  height: 40px;
  /*user-select: none;*/
  user-focus: none;
}

</style>
